import React from 'react';
import styled from 'react-emotion';
import Breadcrumbs from './Breadcrumbs';
import theme from '@jetshop/ui/utils/theme';
import MaxWidth from './MaxWidth';
import { Above } from '@jetshop/ui/Breakpoints';
import LeftAside from './LeftAside';

const Wrapper = styled(MaxWidth)`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px 20px 0;
  background: ${theme('colors.white')};
`;

const Main = styled.div`
  display: flex;
`;

export const Aside = styled.aside`
  width: 20%;
  padding-right: 20px;
  margin-bottom: 40px;
`;

export const Content = styled.section`
  width: 80%;
  padding-left: 20px;
  border-left: 1px solid #eee;

  ${theme('below.lg')} {
    width: 100%;
    padding: 0;
    border: none;
  }
`;

const Layout = ({
  children,
  breadcrumbs,
  route,
  category,
  hideCategoryTree
}) => {
  return (
    <Wrapper>
      <Breadcrumbs {...breadcrumbs} />
      <Main>
        <Above breakpoint="lg">
          <Aside>
            <LeftAside
              route={route}
              category={category}
              hideCategoryTree={hideCategoryTree}
            />
          </Aside>
        </Above>
        <Content>{children}</Content>
      </Main>
    </Wrapper>
  );
};

export default Layout;
